import React from "react";

function extractNumber(value) {
  if (!value) return null;

  const match = String(value).match(/(\d+(\.\d+)?)/);
  return match ? Number(match[1]) : null;
}

function BikeStatGauge({
  value,
  max = 120,
  label,
  unit = "",
  size = 84,
  color = "#5d7259",
  trackColor = "rgba(50, 45, 35, 0.12)",
}) {
  const numericValue = extractNumber(value);

  if (numericValue == null) return null;

  const stroke = label === "Top Speed" ? 8 : 7;
  const radius = (size - stroke) / 2;
  const circumference = 2 * Math.PI * radius;

  const clamped = Math.min(numericValue, max);
  const progress = clamped / max;
  const dashOffset = circumference * (1 - progress);

  return (
    <div
      className="bike-stat-gauge"
      title={`${label}: ${value}`}
      style={{ width: `${size}px` }}
    >
      <div
        className="bike-stat-gauge-circle"
        style={{ width: `${size}px`, height: `${size}px` }}
      >
        <svg
          width={size}
          height={size}
          viewBox={`0 0 ${size} ${size}`}
          className="bike-stat-gauge-svg"
          aria-hidden="true"
        >
          <circle
            cx={size / 2}
            cy={size / 2}
            r={radius}
            fill="none"
            stroke={trackColor}
            strokeWidth={stroke}
          />

          <circle
            cx={size / 2}
            cy={size / 2}
            r={radius}
            fill="none"
            stroke={color}
            strokeWidth={stroke}
            strokeDasharray={circumference}
            strokeDashoffset={dashOffset}
            strokeLinecap="round"
            transform={`rotate(-90 ${size / 2} ${size / 2})`}
            style={{
              transition: "stroke-dashoffset 0.9s ease",
            }}
          />
        </svg>

        <div className="bike-stat-gauge-content">
          <div className="bike-stat-gauge-value">{numericValue}</div>
          <div className="bike-stat-gauge-unit">{unit}</div>
        </div>
      </div>

      <div className="bike-stat-gauge-label">{label}</div>
    </div>
  );
}

export default BikeStatGauge;